import { useSelector } from 'react-redux'
import { selectors } from 'builder/modules/careerProfile'

export const useCareerInsightsStatus = () => {
  const careerInsightsData = useSelector(selectors.careerInsightsData)
  return careerInsightsData?.status
}
